module.exports = __webpack_public_path__ + "public/files/img/desinger.14b14607.png";